import React, { Component } from "react";
import { Image, Modal, Form } from "react-bootstrap";
import { connect } from "react-redux";
import { actionFetchCountries } from "../../../common/redux/actions/actionCountry";
import GlobeIcon from "../../../assets/images/Global.svg";

class AddCountryModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCountry: "",
    };
  }

  componentDidMount() {
    this.props.fetchCountries();
  }

  handleChange = (e) => {
    this.setState({ selectedCountry: e.target.value });
  };

  handleAdd = () => {
    const { selectedCountry } = this.state;
    if (!selectedCountry) return;
    const match = this.countryData.find(
      (c) => c.countryName === selectedCountry,
    );
    if (match && this.props.onAdd) {
      this.props.onAdd({
        code: match.countryCode,
        name: match.countryName,
        currency: match.currency,
      });
    }
    this.setState({ selectedCountry: "" });
  };

  handleClose = () => {
    this.setState({ selectedCountry: "" });
    if (this.props.onHide) this.props.onHide();
  };

  get countryData() {
    const { countries, existingCountryCodes } = this.props;
    if (!countries || countries.length === 0) return [];
    const existing = (existingCountryCodes || []).map((c) => c.toUpperCase());
    return [...countries]
      .filter(
        (item) => !existing.includes((item.countryCode || "").toUpperCase()),
      )
      .sort((a, b) => (a.countryName || "").localeCompare(b.countryName || ""));
  }

  render() {
    const { show } = this.props;
    const { selectedCountry } = this.state;

    return (
      <Modal
        show={show}
        onHide={this.handleClose}
        centered
        className="deliva-popup add-country-modal"
        size="md"
      >
        <Modal.Body>
          <div className="modal-content-wrap">
            <div className="text-center">
              <Image
                src={GlobeIcon}
                className="img-fluid pr-add-country-icon"
              />
              <h4 className="mt-4 font-weight-normal mb-3 fs-24">
                Add Country
              </h4>
              <p className="color-grey">
                Select a country to add pricing configuration for.
              </p>
            </div>

            <Form.Group className="mt-4 px-5 custom-form">
              <Form.Label className="color-head">
                Country <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                as="select"
                className="py-0"
                value={selectedCountry}
                onChange={this.handleChange}
              >
                <option value="">Select Country</option>
                {this.countryData.map((c) => (
                  <option key={c.countryCode} value={c.countryName}>
                    {c.countryName}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <div className="text-center mt-4">
              <button
                className="cancel-btn mr-4 min-w-80"
                onClick={this.handleClose}
              >
                Cancel
              </button>
              <button
                className="b1-btn min-w-80"
                onClick={this.handleAdd}
                disabled={!selectedCountry}
              >
                Add
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  countries: state.country.countries,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCountries: () => dispatch(actionFetchCountries()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddCountryModal);
